import MenuItem1 from '../Images/Menu/menu1.jpeg';
import MenuItem5 from '../Images/Menu/menu5.jpeg';
import MenuItem6 from '../Images/Menu/menu6.jpeg';
import MenuItem7 from '../Images/Menu/menu7.jpeg';
import MenuItem8 from '../Images/Menu/menu8.jpeg';
import MenuItem9 from '../Images/Menu/menu9.jpeg';
import MenuItem10 from '../Images/Menu/menu10.jpeg';
import MenuItem11 from '../Images/Menu/menu11.jpeg';
import MenuItem12 from '../Images/Menu/menu12.jpeg';
import MenuItem13 from '../Images/Menu/menu13.jpeg';
import MenuItem14 from '../Images/Menu/menu14.jpeg';
import MenuItem15 from '../Images/Menu/menu15.jpeg';
import MenuItem16 from '../Images/Menu/menu16.jpeg';
import MenuItem17 from '../Images/Menu/menu17.jpeg';
import MenuItem18 from '../Images/Menu/menu18.jpeg';
import MenuItem19 from '../Images/Menu/menu19.jpeg';
import MenuItem20 from '../Images/Menu/menu20.jpeg';
import MenuItem21 from '../Images/Menu/menu21.jpeg';
import MenuItem22 from '../Images/Menu/menu22.jpeg';

function Menu() {
    return(
        <div>
            {/* cookie flavors */}
            <h4>I offer a variety of cookies and other treats!<br/>Click any of my menu items to see a photo!</h4>
            <div style={{height:"675px"}}>
                <div style={{float: "left", width:"50%"}}>
                    <h4><b>Cookies:</b></h4>
                    <ol style={{fontSize:"10%"}}>

                        <li className="menu-li"><a href="#classic-choco-chip">Classic Chocolate Chip</a></li>
                        <li className="menu-li"><a href="#coconut-matcha">Coconut Matcha</a></li>
                        <li className="menu-li"><a href="#sugar">Sugar Cookie</a></li>
                        <li className="menu-li"><a href="#butterscotch-walnut">Butterscotch Walnut</a></li>
                        <li className="menu-li"><a href="#butterscotch-pecan">Butterscotch Pecan</a></li>
                        <li className="menu-li"><a href="#white-milk-choco-chip">White Chocolate or Milk Chocolate Chip</a></li>
                        <li className="menu-li"><a href="#white-matcha-choco-chip">White Chocolate Chip Matcha</a></li>
                        <li className="menu-li"><a href="#double-choco-chip">Double Chocolate Chip</a></li>
                        <li className="menu-li"><a href="#kitchen-sink">Kitchen Sink</a></li>
                        <li className="menu-li"><a href="#choco-chip-marshmallow">Chocolate Marshmallow Chip</a></li>
                        <li className="menu-li"><a href="#smores">S'Mores</a></li>
                    </ol>
                </div>
                {/* non-cookie flavors */}
                <div style={{float: "right", width:"50%"}}>
                    <h4><b>Others:</b></h4>
                    <ol>
                        <li className="menu-li"><a href="#smores-cake">S'Mores Cake</a></li>
                        <li className="menu-li"><a href="#double-choco-pecan-cake">Double Chocolate Pecan Cake</a></li>
                        <li className="menu-li"><a href="#oreo-cream-cheese">Oreo Cream Cheese Bites</a></li>
                        <li className="menu-li"><a href="#oreo-brownie">Oreo Brownie Bites</a></li>
                        <li className="menu-li"><a href="#choco-chip-banana">Chocolate Chip Banana Bread</a></li>
                        <li className="menu-li"><a href="#zucchini-bread">Zucchini Bread</a></li>
                        <li className="menu-li"><a href="#pumpkin-muffins">Pumpkin Muffins</a></li>
                        <li className="menu-li"><a href="#granola">Granola</a></li>
                    </ol>
                </div>
            </div>
            <h2>Cookies I Offer</h2>

            <img id="classic-choco-chip" className='menu-item-img visible-xs visible-sm' alt="Classic Chocolate Chip Cookies" src={MenuItem16}/>
            <img id="classic-choco-chip" className='menu-item-img-lg hidden-xs hidden-sm' alt="Classic Chocolate Chip Cookies" src={MenuItem16}/>
            <h3 className='menu-item-text'>Classic Chocolate Chip</h3>

            <img id="sugar" className='menu-item-img visible-xs visible-sm' alt="Sugar Cookies" src={MenuItem18}/>
            <img id="sugar" className='menu-item-img-lg hidden-xs hidden-sm' alt="Sugar Cookies" src={MenuItem18}/>
            <h3 className='menu-item-text'>Sugar Cookie</h3>

            <img id="butterscotch-walnut" className='menu-item-img visible-xs visible-sm' alt="Butterscotch Walnut Cookies" src={MenuItem1}/>
            <img id="butterscotch-walnut" className='menu-item-img-lg hidden-xs hidden-sm' alt="Butterscotch Walnut Cookies" src={MenuItem1}/>
            <h3 className='menu-item-text'>Butterscotch Walnut</h3>

            <img id="butterscotch-pecan" className='menu-item-img visible-xs visible-sm' alt="Butterscotch Pecan Cookies" src={MenuItem20}/>
            <img id="butterscotch-pecan" className='menu-item-img-lg hidden-xs hidden-sm' alt="Butterscotch Pecan Cookies" src={MenuItem20}/>
            <h3 className='menu-item-text'>Butterscotch Pecan</h3>

            <img id="white-milk-choco-chip" className='menu-item-img visible-xs visible-sm' alt="White Chocolate or Milk Chocolate Chip Cookies" src={MenuItem13}/>
            <img id="white-milk-choco-chip" className='menu-item-img-lg hidden-xs hidden-sm' alt="White Chocolate or Milk Chocolate Chip Cookies" src={MenuItem13}/>
            <h3 className='menu-item-text'>White Chocolate or Milk Chocolate Chip</h3>

            <img id="white-matcha-choco-chip" className='menu-item-img visible-xs visible-sm' alt="White Chocolate Chip Matcha Cookies" src={MenuItem11}/>
            <img id="white-matcha-choco-chip" className='menu-item-img-lg hidden-xs hidden-sm' alt="White Chocolate Chip Matcha Cookies" src={MenuItem11}/>
            <h3 className='menu-item-text'>White Chocolate Chip Matcha</h3>

            <img id="coconut-matcha" className='menu-item-img visible-xs visible-sm' alt="Coconut Matcha Cookies" src={MenuItem17}/>
            <img id="coconut-matcha" className='menu-item-img-lg hidden-xs hidden-sm' alt="Coconut Matcha Cookies" src={MenuItem17}/>
            <h3 className='menu-item-text'>Coconut Matcha</h3>

            <img id="double-choco-chip" className='menu-item-img visible-xs visible-sm' alt="Double Chocolate Chip Cookies" src={MenuItem7}/>
            <img id="double-choco-chip" className='menu-item-img-lg hidden-xs hidden-sm' alt="Double Chocolate Chip Cookies" src={MenuItem7}/>
            <h3 className='menu-item-text'>Double Chocolate Chip</h3>

            <img id="kitchen-sink" className='menu-item-img visible-xs visible-sm' alt="Kitchen Sink Cookies" src={MenuItem8}/>
            <img id="kitchen-sink" className='menu-item-img-lg hidden-xs hidden-sm' alt="Kitchen Sink Cookies" src={MenuItem8}/>
            <h3 className='menu-item-text'>Kitchen Sink (Includes Pretzels, Chocolate Chips and Potato Chips)</h3>

            <img id="choco-chip-marshmallow" className='menu-item-img visible-xs visible-sm' alt="Chocolate Chip Marshmallow Cookies" src={MenuItem21}/>
            <img id="choco-chip-marshmallow" className='menu-item-img-lg hidden-xs hidden-sm' alt="Chocolate Chip Marshmallow Cookies" src={MenuItem21}/>
            <h3 className='menu-item-text'>Chocolate Chip Marshmallow</h3>

            <img id="smores" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cookies" src={MenuItem6}/>
            <img id="smores" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cookies" src={MenuItem6}/>
            <h3 className='menu-item-text'>S'Mores</h3>
                
            {/* non-cookie items */}
            <br/>
            <h2>Other Treats I Offer</h2>
            
            <img id="smores-cake" className='menu-item-img visible-xs visible-sm' alt="S'Mores Cake" src={MenuItem9}/>
            <img id="smores-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="S'Mores Cake" src={MenuItem9}/>
            <h3 className='menu-item-text'>S'Mores Cake</h3>

            <img id="double-choco-pecan-cake" className='menu-item-img visible-xs visible-sm' alt="Double Chocolate Pecan Cake" src={MenuItem19}/>
            <img id="double-choco-pecan-cake" className='menu-item-img-lg hidden-xs hidden-sm' alt="Double Chocolate Pecan Cake" src={MenuItem19}/>
            <h3 className='menu-item-text'>Double Chocolate Pecan Cake</h3>
            
            <img id="oreo-cream-cheese" className='menu-item-img visible-xs visible-sm' alt="Oreo Cream Cheese Bites" src={MenuItem12}/>
            <img id="oreo-cream-cheese" className='menu-item-img-lg hidden-xs hidden-sm' alt="Oreo Cream Cheese Bites" src={MenuItem12}/>
            <h3 className='menu-item-text'>Oreo Cream Cheese Bites</h3>

            <img id="oreo-brownie" className='menu-item-img visible-xs visible-sm' alt="Oreo Brownie Bites" src={MenuItem10}/>
            <img id="oreo-brownie" className='menu-item-img-lg hidden-xs hidden-sm' alt="Oreo Brownie Bites" src={MenuItem10}/>
            <h3 className='menu-item-text'>Oreo Brownie Bites</h3>

            <img id="choco-chip-banana" className='menu-item-img visible-xs visible-sm' alt="Chocolate Chip Banana Bread" src={MenuItem15}/>
            <img id="choco-chip-banana" className='menu-item-img-lg hidden-xs hidden-sm' alt="Chocolate Chip Banana Bread" src={MenuItem15}/>
            <h3 className='menu-item-text'>Chocolate Chip Banana Bread</h3>

            <img id="zucchini-bread" className='menu-item-img visible-xs visible-sm' alt="Zucchini Bread" src={MenuItem22}/>
            <img id="zucchini-bread" className='menu-item-img-lg hidden-xs hidden-sm' alt="Zucchini Bread" src={MenuItem22}/>
            <h3 className='menu-item-text'>Zucchini Bread</h3>

            <img id="pumpkin-muffins" className='menu-item-img visible-xs visible-sm' alt="Pumpkin Muffins" src={MenuItem5}/>
            <img id="pumpkin-muffins" className='menu-item-img-lg hidden-xs hidden-sm' alt="Pumpkin Muffins" src={MenuItem5}/>
            <h3 className='menu-item-text'>Pumpkin Muffins</h3>

            <img id="granola" className='menu-item-img visible-xs visible-sm' alt="Granola" src={MenuItem14}/>
            <img id="granola" className='menu-item-img-lg hidden-xs hidden-sm' alt="Granola" src={MenuItem14}/>
            <h3 className='menu-item-text'>Granola</h3>
        </div>
    )
}
export default Menu;